export const DS_SPARE_PARTS_GRID_CODE = 'spare-parts-ds';
